import { IntelTechnologiesPagination } from '@components/core/intel-technologies-table/intel-technologies-pagination.component';
import { MainLayout } from '@components/layouts/main.layout';
import { ParentPortfolioTable } from '@components/pages/parent-organizations/components/parent-portfolio-table.component';
import { HelmetWrapper } from '@components/shared/helmet.component';
import { PageviewTracker } from '@components/shared/pageview-tracker.component';
import { Tile } from '@components/shared/tile.component';
import { useParentOrganizationPortfolioQuery } from '@queries/parent-organizations.query';
import { useGetCurrentUser } from '@queries/users.query';
import { routes } from '@routes';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useParentPortfolioQueryParams } from './hooks/use-parent-portfolio-query-params.hook';

export const ParentPortfolioPage: React.FC = () => {
  const { isPending: isUserPending, isInnovator, isSelectedCompanyParentOrganization } = useGetCurrentUser();

  const {
    DEFAULT_SORTING,
    handleLimitChange,
    page,
    queryParams,
    search,
    setPage,
    setSearch,
    setSorting,
    sortingState,
  } = useParentPortfolioQueryParams();

  const { data, isFetching, isPending: isPortfolioPending } = useParentOrganizationPortfolioQuery(queryParams);
  const technologies = data?.technologies ?? [];
  const pagination = data?.pagination;

  useEffect(() => {
    if (!pagination) return;

    const current = page;
    const total = pagination.totalPages ?? 0;

    if (total < 1) {
      if (current !== 1) void setPage(1);
      return;
    }

    if (current > total) {
      void setPage(Math.max(1, total));
    }
  }, [page, pagination, setPage]);

  if (!isUserPending && (!isInnovator || !isSelectedCompanyParentOrganization)) {
    return <Navigate to={routes.home.path} />;
  }

  return (
    <PageviewTracker>
      <HelmetWrapper title="Portfolio" />
      <MainLayout>
        <Tile header={{ title: 'Portfolio' }}>
          <div className="flex flex-col gap-4">
            <ParentPortfolioTable
              isLoading={isPortfolioPending}
              onSearchChange={(value) => void setSearch(value)}
              onSortingChange={(state) => {
                if (!state || state.length === 0) {
                  void setSorting(DEFAULT_SORTING.map((item) => ({ ...item })));
                  return;
                }
                void setSorting(state);
              }}
              search={search}
              sorting={sortingState}
              technologies={technologies}
            />

            {pagination && (
              <IntelTechnologiesPagination
                isFetching={isFetching}
                pagination={pagination}
                onPageChange={(nextPage) => void setPage(Math.max(1, nextPage))}
                onPageSizeChange={handleLimitChange}
              />
            )}
          </div>
        </Tile>
      </MainLayout>
    </PageviewTracker>
  );
};
